import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Why: When Sentry's ErrorBoundary catches a render-time exception on the
 * participant-facing app, the fallback is what the user sees. A bare
 * "Something went wrong" is brand-hostile here — participants are not
 * internal users. D7 in the Sentry install spec requires a polished,
 * localized fallback.
 * Scope: Visual changes land here; keys stay in the locale JSONs.
 * SRP: Render a localized, accessible error-boundary fallback for the
 * Program app.
 *
 * Paired with `Sentry.ErrorBoundary` in `src/index.js`.
 */
const ErrorBoundaryFallback = () => {
  const { t } = useTranslation();
  return (
    <div
      role="alert"
      style={{
        padding: 24,
        textAlign: 'center',
        maxWidth: 480,
        margin: '48px auto',
      }}
    >
      <h2>{t('error_boundary_title')}</h2>
      <p>{t('error_boundary_message')}</p>
    </div>
  );
};

export default ErrorBoundaryFallback;
